import './style.scss';

const floorImageToggle = () => {
  const floorContent = document.querySelector('.wp-block-ths-blocks-floor-plan');
  const firstBtn = document.querySelector('.wp-block-ths-blocks-floor-plan-btn .wp-block-image:first-child');
  const secoundBtn = document.querySelector('.wp-block-ths-blocks-floor-plan-btn .wp-block-image:last-child');

  if (!floorContent) return;
  if (!firstBtn) return;
  if (!secoundBtn) return;

  firstBtn.addEventListener('click', () => {
    if (floorContent.classList.contains('is-second-active') === true) {
      floorContent.classList.remove('is-second-active');
    }
    floorContent.classList.add('is-first-active');
  })

  secoundBtn.addEventListener('click', () => {
    if (floorContent.classList.contains('is-first-active') === true) {
      floorContent.classList.remove('is-first-active');
    }

    floorContent.classList.add('is-second-active');
  })

}
floorImageToggle();